import { activeClientRegistry } from "./activeClientRegistry";
/** DSN project id of the currently active (capable) app, or undefined when none is mounted. */
const activeProjectId = () => activeClientRegistry.activeProjectId();
export { activeProjectId };
